import _ from 'lodash';
import React from 'react';
import Slider from 'react-slider';
import shallowCompare from '../../lib/shallowCompare';
import { formatCurrency } from '../../../client/lib/utils';
import styles from './index.sass';

class PriceFilterSlider extends React.Component {
  static propTypes = {
    minPriceInCents: React.PropTypes.number,
    maxPriceInCents: React.PropTypes.number,
    filters: React.PropTypes.array
  };

  static defaultProps = {
    minPriceInCents: 0,
    maxPriceInCents: 20000,
    filters: []
  };

  constructor(props) {
    super(props);

    this.state = this.getStateFromProps(props);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.filters !== this.props.filters) {
      this.setState(this.getStateFromProps(nextProps));
    }
  }

  roundToHundreds(val) {
    if(!val) {return val;}
    return Math.round(val / 100) * 100;
  }

  getStateFromProps(props) {
    let minValue, maxValue;
    props.filters.forEach(filter => {
      switch(filter.type) {
        case 'min_price_in_cents':
          minValue = filter.value;
          break;
        case 'max_price_in_cents':
          maxValue = filter.value;
          break;
        default:
          break;
      }
    });
    return {
      minValue: this.roundToHundreds(minValue || props.minPriceInCents),
      maxValue: this.roundToHundreds(maxValue || props.maxPriceInCents)
    };
  }

  handleOnChange(values) {
    this.setState({
      minValue: this.roundToHundreds(values[0]),
      maxValue: this.roundToHundreds(values[1])
    });
  }

  handleOnAfterChange(values) {
    let filters = [];
    let minValue = this.roundToHundreds(values[0]);
    let maxValue = this.roundToHundreds(values[1]);
    if(minValue > this.roundToHundreds(this.props.minPriceInCents)) {
      filters.push({type: 'min_price_in_cents', value: minValue});
    }
    if(maxValue < this.roundToHundreds(this.props.maxPriceInCents)) {
      filters.push({type: 'max_price_in_cents', value: maxValue});
    }
    this.props.onChange(filters);
  }

  render() {
    let { minValue, maxValue } = this.state;
    let sliderProps = {
      value: [minValue, maxValue],
      withBars: true,
      step: 100,
      minDistance: 1000,
      min: this.props.minPriceInCents,
      max: this.props.maxPriceInCents,
      pearling: true,
      className: styles.slider,
      barClassName: 'bar', // Global style for appended index
      handleClassName: 'handle', // Global style for appended index
      onChange: this.handleOnChange.bind(this),
      onAfterChange: this.handleOnAfterChange.bind(this)
    };

    return (
      <div className={styles.priceFilterSlider}>
        <span className={styles.minPriceLabel}>{formatCurrency(minValue, {withoutTrailingZeros: true})}</span>
        <Slider {...sliderProps} />
        <span className={styles.maxPriceLabel}>{formatCurrency(maxValue, {withoutTrailingZeros: true})}{maxValue === this.props.maxPriceInCents ? '+' : ''}</span>
      </div>
    );
  }
}

export default PriceFilterSlider;



// WEBPACK FOOTER //
// banquet/components/PriceFilterSlider/index.js